import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "map-toolbar" }
const _hoisted_2 = { class: "selector__label" }

import IconChevronBottom from "@/assets/icons/IconChevronBottom.vue";
import {MAP_DISPLAY_PARAMS_LABELS, type MapDisplayParamsKey} from "@/composables/constants/params";
import {ref} from "vue";
import IconStars from "@/assets/icons/IconStars.vue";
import {useStore} from "@/stores";
import ForecastButton from "@/components/ui/buttons/ForecastButton.vue";
import MonthYearPicker from "@/components/ui/input/MonthYearPicker.vue";
import {useFilesStore} from "@/stores/files";
import {storeToRefs} from "pinia";
import RegionSelector from "@/components/ui/input/RegionSelector.vue";
import type {DistrictKey} from "@/composables/functions/getDistrictName";
import type {RegionKey} from "@/composables/functions/getRegionName";


export default /*@__PURE__*/_defineComponent({
  __name: 'MapToolbar',
  props: {
    "selectedParams": {required: true},
    "selectedParamsModifiers": {},
    "selectedMonth": {required: true},
    "selectedMonthModifiers": {},
    "selectedYear": {required: true},
    "selectedYearModifiers": {},
    "selectedDistrict": {required: true},
    "selectedDistrictModifiers": {},
    "selectedRegion": {required: true},
    "selectedRegionModifiers": {},
  },
  emits: ["update:selectedParams", "update:selectedMonth", "update:selectedYear", "update:selectedDistrict", "update:selectedRegion"],
  setup(__props) {

const selectedParams = _useModel<MapDisplayParamsKey>(__props, "selectedParams");
const selectedMonth = _useModel<string>(__props, "selectedMonth");
const selectedYear = _useModel<number>(__props, "selectedYear");
const selectedDistrict = _useModel<DistrictKey | null>(__props, "selectedDistrict");
const selectedRegion = _useModel<RegionKey | null>(__props, "selectedRegion");

const mainStore = useStore();
const filesStore = useFilesStore();

const { filesData } = storeToRefs(filesStore);

// Отображение модального окна параметров
const isShowParamsSelect = ref(false);
const toggleParamsSelect = (): void => {
  isShowParamsSelect.value = !isShowParamsSelect.value;
};

return (_ctx: any,_cache: any) => {
  const _component_ListItem = _resolveComponent("ListItem")!
  const _component_ListView = _resolveComponent("ListView")!
  const _component_SimpleDropdown = _resolveComponent("SimpleDropdown")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createBlock(_component_SimpleDropdown, {
      "use-cross-icon": false,
      teleport: "#app",
      "is-visible": isShowParamsSelect.value,
      "max-height": "400px",
      "max-width": "290px",
      "use-searchbar": false,
      offset: 0,
      onClose: toggleParamsSelect
    }, {
      trigger: _withCtx(() => [
        _createElementVNode("div", {
          class: "selector",
          onClick: toggleParamsSelect
        }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(MAP_DISPLAY_PARAMS_LABELS)[selectedParams.value]), 1),
          _createElementVNode("span", {
            class: _normalizeClass(["selector__icon", {'selector__icon--active': isShowParamsSelect.value}])
          }, [
            _createVNode(IconChevronBottom)
          ], 2)
        ])
      ]),
      "dropdown-item": _withCtx(() => [
        _createVNode(_component_ListView, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MAP_DISPLAY_PARAMS_LABELS), (value, key) => {
              return (_openBlock(), _createBlock(_component_ListItem, {
                key: key,
                modelValue: selectedParams.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedParams).value = $event)),
                item: key,
                "use-checkbox": false
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(value), 1)
                ]),
                _: 2
              }, 1032, ["modelValue", "item"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["is-visible"])), [
      [_directive_tooltip, _unref(MAP_DISPLAY_PARAMS_LABELS)[selectedParams.value], "0"]
    ]),
    _createVNode(MonthYearPicker, {
      "model-month": selectedMonth.value,
      "onUpdate:modelMonth": _cache[1] || (_cache[1] = ($event: any) => ((selectedMonth).value = $event)),
      "model-year": selectedYear.value,
      "onUpdate:modelYear": _cache[2] || (_cache[2] = ($event: any) => ((selectedYear).value = $event))
    }, null, 8, ["model-month", "model-year"]),
    _createVNode(RegionSelector, {
      "selected-district": selectedDistrict.value,
      "onUpdate:selectedDistrict": _cache[3] || (_cache[3] = ($event: any) => ((selectedDistrict).value = $event)),
      "selected-region": selectedRegion.value,
      "onUpdate:selectedRegion": _cache[4] || (_cache[4] = ($event: any) => ((selectedRegion).value = $event))
    }, null, 8, ["selected-district", "selected-region"]),
    _createVNode(ForecastButton, {
      class: "map-toolbar__forecast",
      disabled: !_unref(mainStore).forecastStatus || _unref(filesData)?.results.length === 0,
      size: "large",
      active: _unref(mainStore).forecastStatusDisplay,
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(mainStore).toggleForecastStatusDisplay()))
    }, {
      default: _withCtx(() => [
        _createVNode(IconStars),
        _cache[6] || (_cache[6] = _createTextVNode(" Прогноз 2025 ", -1))
      ]),
      _: 1
    }, 8, ["disabled", "active"])
  ]))
}
}

})